(
    function (skyward, $, undefined)
    {
        skyward.assetPopup = skyward.assetPopup || {};
        var dialog;
        var init = function (selector)
        {
            $(selector).find('.button.addAssetRow').on('click', function (event)
            {
                appendAssetRow(selector);
            });
        };

        var createNewPopup = function (data)
        {
            var popup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + 'Asset/Asset/AssetPopup?renderType=contentOnly',
                    data: data,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            return popup;
        };

        var show = function ()
        {
            var button = $(this);
            var data = button.data();

            var browseName = skyward.browse.getCurrentBrowseName();
            var newRowData = $(this).closest(".browseRowOptions").data();
            if (browseName != null && newRowData != null)
            {
                skyward.browse.setCurrentRecord(browseName, newRowData.row);
            }

            var content = createNewPopup(data);
            var browse = skyward.browse.browseList[browseName];

            function saveData()
            {
                var selector = "#assetPopupContent";
                var container = $(selector);
                var promise = skyward.ajax.getAllInputElements(selector).then(postedData =>
                {
                    postedData['preSaveWarningHash'] = container.data('preSaveWarningHash') || "";
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "Asset/Asset/SaveAssets",
                            type: "POST",
                            dataType: "json",
                            data: postedData
                        });
                });

                promise.then(function (promiseData)
                {
                    if (!promiseData.success)
                    {
                        skyward.validation.displayValidationMessages(promiseData, container, $(selector).find("#lblAssetsErrorMessage"))
                        postedData['preSaveWarningHash'] = promiseData.preSaveWarningHash;
                    }
                    else
                    {
                        dialog.close();
                    }
                });
            }
            var saveButton = { text: "Save", click: saveData, icon: "Save" }
            dialog = skyward.modalLayer.showDialog(data.title, content, [saveButton, { text: "Cancel", icon: "Cancel" }],
                {
                    allowNoButtons: true,
                    draggable: true,
                    id: 'AssetPopupModal',
                    additionalClasses: 'workflowPopup'
                });
        };

        var appendAssetRow = function (selector)
        {
            var element = $(selector).find(".button.addAssetRow");
            if (!skyward.buttonManager.isElementDisabled(element))
            {
                skyward.buttonManager.setClass(".button.addAssetRow");
                return skyward.ajax.getAllInputElements(selector).then(data =>
                {
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + 'Asset/Asset/AppendAssetRow',
                            data: data,
                            type: 'POST',
                            dataType: 'json',
                            success: function (successData)
                            {
                                var browseTable = $(selector).find("#AssetPopupBrowse");
                                var browseBody = browseTable.find(".unlockedBrowseTableBody");
                                browseBody.append(successData.Content);
                                skyward.window.notifyDOMLoad(successData.Id);
                                dialog.animateModalContents();
                                skyward.buttonManager.setClickInProgress(false);
                            }
                        });
                });
            }
        };

        var removerow = function ()
        {
            var data = $(this).data();
            $("#" + data.formname).remove();
            dialog.animateModalContents();
        };

        var events =
        {
            'show': show,
            'removerow': removerow
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('assetPopup', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);